// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../third/jquery.slick';

export default class ArticlesSlider extends WebComponent {
  didMount() {
    $(this.element).slick({
      mobileFirst: true,
      infinite: false,
      arrows: true,
      dots: false,
      touchThreshold: 10,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      prevArrow: '<span class="articles-slider__arrow articles-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#right"></use></svg></span>',
      nextArrow: '<span class="articles-slider__arrow articles-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#left"></use></svg></span>',
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    // eslint-disable-next-line no-undef
    $(window).resize(() => {
      $(this.element).slick('resize');
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ArticlesSlider.js